import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {AuthService} from "../providers/auth.service";
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
//import { map } from 'rxjs/operator/map'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(public auth: AuthService, public router: Router, private http: HttpClient) { }


    canActivate() {
        return this.auth.isAuthenticated();
    }

    //canActivate(): boolean {

    //    this.auth.isAuthenticated().subscribe(resp => {

    //        console.log(resp);

    //        if (resp == true) {
    //            return true
    //        }

    //    }),
    //        (error => {
    //            console.log(error);
    //        })

    //    this.router.navigate(['login']);
    //    return false;
    //}
        

    //    if (!this.auth.isAuthenticated()) {
    //        this.router.navigate(['login']);
    //        return false;
    //    }
    //    return true;
    //}
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts